<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" rx="6" fill="#00539B"/>
<g clip-path="url(#clip0)">
<path d="M30.3962 8L30.8838 10.4526C16.3297 12.2447 8.3158 21.5015 8.38469 31C5.68559 19.4904 17.6602 8.40818 30.3962 8Z" fill="#F37321"/>
<path d="M31.0954 15.9604C20.6906 17.3531 15.5063 24.2554 15.6041 30.4429C14.435 26.1456 15.6948 22.8101 18.1945 19.6253C20.6942 16.4404 24.0549 14.5852 27.9504 13.7478C30.76 13.1329 30.6477 12.497 31.0954 15.9604Z" fill="#F37321"/>
<path d="M31.4489 19.2871L31.9927 21.8466C27.0985 22.8819 23.3969 24.9193 22.7643 30.0803C20.8374 25.783 24.9105 19.9598 31.4489 19.2871Z" fill="#F37321"/>
</g>
<defs>
<clipPath id="clip0">
<rect width="24" height="23" fill="white" transform="translate(8 8)"/>
</clipPath>
</defs>
</svg>
